<template>
  <div class="home">
    <Header/>
    <!--轮播图-->
    <div class="scroll_banner">
      <div class="swiper-container" id="scrollBanner">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in scrollList">
            <router-link :to="item.url" class="swiper-img">
              <img class="img_fit" :src="item.img_url">
            </router-link>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- Add Navigation -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <section class="section1">
      <div class="container">
        <h2>信用示范创建 <br>
          专项咨询与辅导服务</h2>
        <router-link to="/projects/6" class="go_detail">了解详情</router-link>
      </div>
    </section>
    <section class="section2">
      <div class="container">
        <h4>服务与产品</h4>
        <p class="sub_title">团队多年来致力于为政府部门、行业组织、广大企业提供有针对性、有亮点、专业、可靠、有实效的信用服务与产品，对上百款信用服务与产品进行整合与梳理，已形成两块领域、三大维度、海
          量解决方案。</p>
        <ul class="service">
          <li class="service_item flex flex_between" :class="{'active':showNum==1}" @click="showNum=1">
            <div class="service_item_title">政府信用服务 <img src="@/assets/index/service_icon1.png" alt=""></div>
            <div class="content_bg">
              <div class="service_item_content flex flex_between flex_wrap">
                <router-link to="/zhengxinfu/0" class="content_item column2">
                  <b>政信服·文案撰写与咨询培训</b>
                  <p>
                    为各级政府部门提供有高度、有亮点、可实操的信用领域制度撰写服务，如信用“十四五”规划、实施方案、管理办法、目录清单、可研报告等；并可提供顶级智库小型现场咨询研讨、信用建设专题培训等多样化咨询服务。</p>
                </router-link>
                <router-link to="/module?id=9&text=信用监管套餐" class="content_item column2">
                  <b>信用监管套餐</b>
                  <p>包含身份认证、信用承诺管理、信用分级分类监管、信用预警等功能的全流程信用监管应用系统。与现有行政业务系统完美实现有机结合，让信用监管立体、高效、精准。该套餐可任意组合或单点。</p>
                </router-link>
                <router-link to="/module?id=7&text=三维信用诊断系统" class="content_item column3">
                  <b>企业三维信用体检</b>
                  <p>基于各政府部门公共信用信息，通过系统技术分析自动实现企业信用画像、等级或分数生成，为跨部门协同信用监管提供智能化参考依据。</p>
                </router-link>
                <div class="content_item column3" @click="showContact('信用换·惠民便企平台',0)">
                  <b>信用换·惠民便企平台</b>
                  <p>以小程序等便捷形式呈现的信用惠民便企公共服务平台，政府搭台，守信市民与诚信商家唱戏，以信用换折扣、省时、便利与更高服务层级，实现信用价值。</p>
                </div>
                <div class="content_item column3" @click="showContact('基层信用宝',0)">
                  <b>基层信用宝</b>
                  <p>专为街道、乡村等基层单位管理辖区居民与企业设计，轻松实现信用档案、信息录入、归集与分析等功能，可与现有业务系统无缝结合，实现自动化办公。</p>
                </div>
              </div>
            </div>

          </li>
          <li class="service_item flex flex_between" :class="{'active':showNum==2}" @click="showNum=2">
            <div class="service_item_title">企业信用服务 <img src="@/assets/index/service_icon2.png" alt=""></div>
            <div class="content_bg">
              <div class="service_item_content flex flex_wrap">
                <div class="content_left">
                  <router-link to="/module?id=8&text=企业信管家" class="content_item flex flex_between">
                    <div>
                      <b>企业信管家</b>
                      <p>
                        基于企业原有业务平台即可部署的定制化信用管理系统，将企业内外部海量数据资源整合，对业务指标进行三维信用构建，并通过机器学习方法不断完善管理模型，助力企业掌控自己、了解产业链交易对手，防范风险，提升信用管理水平。</p>
                    </div>
                    <img src="@/assets/index/service4.png" alt="">
                  </router-link>
                  <router-link to="/module?id=11&text=信用预警机" class="content_item flex flex_between">
                    <div class="content_item_left flex flex_between flex_column">
                      <b>信用预警机</b>
                      <p>以三维信用评价为基础，批量化实现指定企业跟踪预警的信用风险预警系统。企业可自主预设预警条件，通过信息订阅、业务系统推送等方式，实现对指定目标企业精准、高效、实时的事前信用管理。</p>
                    </div>
                    <img src="@/assets/index/service6.png" alt="">
                  </router-link>
                </div>
                <router-link to="/module?id=7&text=三维信用诊断系统" class="content_right">
                  <div class="content_item">
                    <b>三维信用体检</b>
                    <p>以企业内外部信用信息，特别是外部海量数据资源信息为基础，通过系统技术分析自动实现企业信用监测、画像、等级或评分，为企业提供极具业务针对性与有效性的市场化信用评价产品与服务。</p>
                  </div>
                </router-link>
              </div>
            </div>
          </li>
          <li class="service_item flex flex_between" :class="{'active':showNum==3}" @click="showNum=3">
            <div class="service_item_title">行业信用服务 <img src="@/assets/index/service_icon3.png" alt=""></div>
            <div class="content_bg">
              <div class="service_item_content flex flex_wrap">
                <div class="content_left">
                  <router-link to="/module?id=10&text=信用档案系统" class="content_item flex flex_between">
                    <div>
                      <b>企业信用档案</b>
                      <p>
                        为行业组织智能化了解与管理会员定制的全流程信用档案管理系统，可记录、查询、评价管理会员的承诺、践诺、参与信用培训、信用奖惩与综合信用评价等事项情况，有助于快速提升行业现代化信用管理水平。</p>
                    </div>
                    <img src="@/assets/index/service2.png" alt="">
                  </router-link>
                  <div class="content_item flex flex_between" @click="showContact('信云通·行业信用信息服务平台',0)">
                    <div class="content_item_left">
                      <b>信云通·行业信用信息服务平台</b>
                      <p>为行业组织提供的一站式信用管理服务平台设计，高效全面实现产业链信用信 息归集、信用档案建设、信用评价、信用信息共享与交换、合同履约管理、外
                        联对接等海量功能，着力打造行业组织信用管理与服务一站通。</p>
                    </div>
                    <img src="@/assets/index/service3.png" alt="">
                  </div>
                </div>
                <div class="content_right" @click="showContact('履约宝',0)">
                  <div class="content_item">
                    <b>履约宝</b>
                    <p>可在原有行业信息化平台上独立装载的合同履约管理系统，创新应用区块链技术，实现履约监督敦促与保护商业隐私的平衡，增强行业自 律约束，实质性提升合作伙 伴信任度。</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="section3">
      <div class="container">
        <h4>别忘了给您关心的企业做个信用体检！</h4>
        <p class="subtitle">从诚信、合规、践约三大信用维度出发，对行政处罚、不良信用行为、信用黑名单情况、政府部门评价、行政奖励表彰、履约行为等方面开展企业信用体检，一键诊断企业信用症结！</p>
        <div class="input-group">
          <input type="text" class="input-group-input" placeholder="请输入企业名称" v-model="searchValue">
          <button class="input-group-btn" @click="linkXinyongtest(searchValue)">
            <span class="iconfont">&#xe634;</span>马上体检
          </button>
        </div>
        <dl class="flex flex_wrap">
          <dt>热门体检企业：</dt>
          <dd v-for="item in searchKeys" @click="linkXinyongtest(item.company_name)">{{ item.company_name }}</dd>
        </dl>
      </div>
    </section>

    <section class="section4">
      <div class="container">
        <h3>部分研究成果</h3>
        <p class="subtitle">团队专业化积累离不开十余年的研究与探索，近五年来，团队编制高质量信用研究报告数十篇，生成信用研究与总结百余份，参与编写完成五本信用书籍，获得合作伙伴的一致好评</p>
        <ul class="success flex flex_between">
          <li class="success_item">
            <div class="item_bg">
              <div class="flex flex_center">开拓·奋进 2014-2020 <br>
                中国工程建设行业信用体系 <br>
                建设回顾
              </div>
              <img src="@/assets/index/book1.png" alt="">
            </div>
          </li>
          <li class="success_item">
            <div class="item_bg">
              <div class="flex flex_center">以信用建设优化营商环境 <br>
                研究报告
              </div>
              <img src="@/assets/index/book2.jpg" alt="">
            </div>
          </li>
          <li class="success_item">
            <div class="item_bg">
              <div class="flex flex_center">水利建设行业信用建设 <br>
                发展研究报告
              </div>
              <img src="@/assets/index/book3.jpg" alt="">
            </div>

          </li>
          <li class="success_item">
            <div class="item_bg">
              <div class="flex flex_center">中国长租行业信用建设 <br>
                发展报告
              </div>
              <img src="@/assets/index/book4.jpg" alt="">
            </div>
          </li>

        </ul>
      </div>
    </section>
    <section class="section_contact" :class="{'fixed':fixed}">
      <div class="container">
        <Contact/>
      </div>
    </section>
    <transition name="fade">
      <a class="right_modal" v-if="showModal">
        <img src="@/assets/index/right_modal.png" alt="" @click="goLink">
        <span class="iconfont" @click="showModal=!showModal">&#xe612;</span>
      </a>
    </transition>
    <UserNeed ref="userNeed"/>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import Contact from "@/components/Contact";
import UserNeed from "@/components/UserNeed";
import '@/js/message';

import { getHomeData } from "@/api";

export default {

  name: 'home',
  data() {
    return {
      fixed: true,
      showNum: 1,
      scrollList: [],
      searchKeys: [],
      searchValue: '北京政通征信有限公司',
      showModal: true
    }
  },
  components: {
    Contact, UserNeed
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getData();
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 1600) {
        this.fixed = false;
      } else {
        this.fixed = true;
      }
    },
    goLink() {
      window.open('http://www.gxxinyong.com', "_blank")
    },
    getData() {
      getHomeData().then(res => {
        this.searchKeys = res.key_list;
        this.scrollList = res.scroll_list;
        setTimeout(() => {
          var swiper = new Swiper('#scrollBanner', {
            loop: true, // 设置为true 则开启loop模式
            autoplay: 5000,// 自动切换时间
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            speed: 600
          });
        }, 500)
      })
    },
    showContact(title, id) {
      this.$refs.userNeed.showModal(title, id);
    },
    linkXinyongtest(value) {
      if (value) {
        this.$router.push({ path: '/xinyongtest', query: { searchKey: value } })
      } else {
        toast({ msg: '请输入要搜索的公司名称!', type: 'warning', time: 3e3 });
      }
    }
  }
}
</script>
<style>
  .swiper-button-next, .swiper-button-prev {
    width: 60px;
    height: 60px;
    margin-top: -30px;
  }

  .swiper-button-next {
    right: 30px;
    background: url("../assets/arrow_right.png") 0 0 no-repeat;
    background-size: 60px;
  }

  .swiper-button-prev {
    left: 30px;
    background: url("../assets/arrow_left.png") 0 0 no-repeat;
    background-size: 60px;
  }

</style>
<style lang="less" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .swiper-img {
    width: 100%;

    img {
      width: 100%;
      display: block;
    }
  }

  .carousel-control {
    opacity: 1;
    font-size: 52px;
    color: #A2A2A2;
    top: 50%;
    bottom: initial;
    transform: translateY(-50%);
    text-shadow: 0 1px 2px rgba(0, 0, 0, .3);
  }

  .section1 {
    position: relative;
    background: url("../assets/index/bg1.jpg") 50% 50% no-repeat;
    background-size: cover;

    .container {
      padding: 40px 0;

      h2 {
        font-size: 42px;
        color: #fff;
        margin-bottom: 50px;
        line-height: 1.4;
        font-weight: 500;
      }

      .go_detail {
        display: inline-block;
        width: 177px;
        height: 53px;
        background: #FF8607;
        text-align: center;
        line-height: 53px;
        font-size: 26px;
        color: #fff;
        transition: all ease .2s;

        &:hover {
          background: rgba(255, 134, 7, .8);
        }
      }
    }
  }

  .section2 {
    padding: 34px 0;
    background: #11385B;
    color: #fff;

    h4 {
      font-size: 34px;
      font-weight: 500;
    }

    .sub_title {
      color: #EAF4FF;
      font-size: 14px;
      margin: 12px 0 30px;
    }

    .service {
      overflow: hidden;
      height: 100%;
      height: 410px;

      .service_item {
        width: 90px;
        overflow: hidden;
        float: left;
        transition: all .5s;

        .service_item_title {
          cursor: pointer;
          width: 90px;
          padding: 48px 20px;
          font-size: 36px;
          font-weight: 500;
          text-align: center;
          line-height: 1.2;
          box-sizing: border-box;

          img {
            width: 49px;
            height: 49px;
            margin-top: 20px;
          }
        }

        .content_bg {
          width: 0;
        }

        .service_item_content {
          width: 871px;
          overflow: hidden;
          padding: 30px 45px 30px 10px;

          .content_item {
            height: 166px;
            border: 1px solid #F3F3F3;
            padding: 30px 20px;
            margin-right: 10px;
            transition: all .3s;
            box-sizing: border-box;
            color: #fff;
            cursor: pointer;

            .content_item_left {
              height: 100%;
            }

            b {
              font-size: 20px;
              display: block;
              padding-bottom: 10px;
            }

            p {
              font-size: 14px;
              text-align: justify;
              margin-bottom: 0;
              line-height: 1.6;
            }

            &:hover {
              text-decoration: underline;
              background: #fff;
              box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.2);
              border: 1px solid rgba(0, 0, 0, 0.2);
            }
          }
        }

        &:nth-child(1) {
          background: #BD1A2D;

          .service_item_content {
            width: 890px;

            .content_item {
              &.column2 {
                width: calc(50% - 10px);
                margin-bottom: 12px;
                padding: 20px 25px;
              }

              &.column3 {
                width: calc(33.33% - 10px);
                padding: 20px;
                letter-spacing: -1px;
              }

              &:hover {
                color: #BD1A2D;
              }
            }

          }
        }

        &:nth-child(2), &:nth-child(3) {
          background: #005293;

          .service_item_content {
            align-items: stretch;

            .content_item {
              margin-right: 0;
              height: 166px;

              &:hover {
                color: #005293;
              }
            }

            .content_right {
              width: 218px;

              .content_item {
                height: 345px;
                background: url("../assets/index/service5.png") 80% 90% no-repeat;
                background-size: 96px;

                &:hover {
                  color: #005293;
                  background: #fff url("../assets/index/service5.png") 80% 90% no-repeat;
                  background-size: 96px;
                }
              }
            }

            .content_left {
              width: 640px;
              margin-right: 12px;

              .content_item {
                margin-bottom: 12px;
                align-items: flex-end;

                img {
                  width: 83px;
                  height: 89px;
                  margin-left: 23px;
                }
              }
            }

          }
        }

        &:nth-child(3) {
          background: #00747B;

          .service_item_content {
            .content_item {
              &:hover {
                color: #00747B;
              }
            }

            .content_right {
              .content_item {
                background: url("../assets/index/service1.png") 80% 90% no-repeat;
                background-size: 96px;

                &:hover {
                  color: #00747B;
                  background: #fff url("../assets/index/service1.png") 80% 90% no-repeat;
                  background-size: 96px;
                }
              }
            }
          }
        }
      }

      .service_item.active {
        width: calc(100% - 180px);

        .content_bg {
          width: 100%;
        }
      }
    }
  }

  .section3 {
    background: url("../assets/index/bg2.png") 50% 50% no-repeat;
    background-size: cover;
    padding: 50px 0;
    text-align: center;
    color: #fff;

    h4 {
      font-size: 26px;
      font-weight: 500;
    }

    .subtitle {
      font-size: 14px;
      margin: 15px 0 20px;
    }

    .input-group {
      position: relative;
      background: #fff;
      border: 1px solid #CCCCCC;
      border-radius: 4px;
      text-align: left;
      padding: 8px 12px;

      .input-group-input {
        height: 40px;
        background: none;
        border: none;
        font-size: 16px;
        width: 70%;
      }

      .input-group-btn {
        position: absolute;
        right: 8px;
        top: 8px;
        color: #fff;
        width: 98px;
        height: 38px;
        background: #2678CB;
        border-radius: 4px;

        .iconfont {
          font-weight: 500;
        }

      }
    }

    dl {
      font-size: 16px;
      line-height: 30px;
      margin-top: 20px;

      dt {
        font-weight: normal;
      }

      dd {
        margin-right: 15px;
        cursor: pointer;
        padding: 0 5px;

        &:hover {
          background: #fff;
          box-shadow: 4px 6px 16px 0px rgba(0, 0, 0, 0.1);
          border-radius: 15px;
          color: #005293;
        }
      }
    }
  }

  .section4 {
    padding: 40px 0;

    h3 {
      font-size: 34px;
      font-weight: 500;
      color: #000;
    }

    .subtitle {
      font-size: 14px;
      color: #919191;
      margin: 12px 0 40px;
    }

    .success {
      width: calc(100% + 40px);
      margin-left: -20px;

      .success_item {
        width: 25%;
        padding: 0 20px;

        .item_bg {
          background: #F3F3F3;
          border-radius: 12px;
          overflow: hidden;
          text-align: center;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

          div {
            height: 120px;
            padding: 22px 0;
            background: #005293;
            font-size: 18px;
            color: #fff;
            justify-content: center;
            box-sizing: border-box;
          }

          img {
            width: 153px;
            margin: 24px 0 37px;
          }
        }
      }
    }
  }

  .right_modal {
    position: fixed;
    top: 150px;
    right: 100px;
    z-index: 10;
    text-align: center;

    img {
      border-radius: 16px;
      width: 175px;
      display: block;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
    }

    .iconfont {
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 50%;
      display: inline-block;
      font-size: 14px;
      font-weight: 600;
      margin-top: 9px;
      color: #e1f2ff;
      border: 2px solid #e1f2ff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
      /*border: 2px solid rgba(37,112,203,.65);*/
      //  background: rgba(255,255,255,.25);

    }
  }

</style>
